
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as login0BGgKyS9MO99R8r15dbT80saTSiz17hh1jwvSebIrDMMeta } from "/app/pages/(auth)/login.vue?macro=true";
import { default as testbRGjoaocOXkK8PpWJGyuPBEOQRQ5mflJ3LnWH_45v4X_UMeta } from "/app/pages/(dashboard)/test.vue?macro=true";
import { default as indexiba_riI9_XHJx5HMWAcIYNqHDW2Eir5UiZPbge_iBV4Meta } from "/app/pages/(dashboard)/index.vue?macro=true";
import { default as _91_46_46_46error_93XyHIKHCvvRYobyLISpXH15MUGAQ_vTHAKGVa8qYP0oUMeta } from "/app/pages/(dashboard)/[...error].vue?macro=true";
import { default as indexP4rOxTV4X__45CodgP5Sg17grb26Tnz6K67RKmKfrSxPwMeta } from "/app/pages/(dashboard)/cms/partner/(index)/index.vue?macro=true";
import { default as createo3wT5zcebaTgjmealGNCecTD9lbpB2ZOw4SAi4C0CEwMeta } from "/app/pages/(dashboard)/cms/partner/(index)/create.vue?macro=true";
import { default as _91id_93BvTr9ieAV5JQr1FJW1hPcOQI4heqt_45cdjbJUPq6e598Meta } from "/app/pages/(dashboard)/cms/partner/(index)/edit/[id].vue?macro=true";
import { default as indexJcNmof0LF_ek6_pjFJAi2CeyOCDgmM4_453RspE07q_45gIMeta } from "/app/pages/(dashboard)/cms/partner/application/index.vue?macro=true";
import { default as partnerBYIksIcGIwN6f8_45LhQ0QAG1Ud5F_45P6D8FfV82baWDmoMeta } from "/app/pages/(dashboard)/cms/partner.vue?macro=true";
import { default as indexcbxlfSZxGMo_9tA9v0Fzme0ts6QII0ON6RojFCeTRZoMeta } from "/app/pages/(dashboard)/currency/index.vue?macro=true";
import { default as refundjvBE3p2wN5aZSU5BugNj6qGSLQ5ZewtdUfwPi8wl8a0Meta } from "/app/pages/(dashboard)/cms/sheets/refund.vue?macro=true";
import { default as ikasE4MCITIpmMiOPal58dh7ykrriC8ISH8pBRN1cbqq_45EkMeta } from "/app/pages/(dashboard)/cms/shipping/ikas.vue?macro=true";
import { default as supportk1S3T_0OLxcv8k4zQioO6p_45hDV9cjyOW5a0qDmwjKMgMeta } from "/app/pages/(dashboard)/cms/sheets/support.vue?macro=true";
import { default as indexZVt27VWFoc1D4l2eE9rIvl59RTr7GaUeo9w6qEpYZu0Meta } from "/app/pages/(dashboard)/cms/electrician/index.vue?macro=true";
import { default as createFA6wVX_45HyAM_tCwoCvIAmYWZvAfdUflzJhVSRZiAMFAMeta } from "/app/pages/(dashboard)/cms/electrician/create.vue?macro=true";
import { default as indexkK4ubEVcwaTM7ciNt9CqcmV5VlpRaUg4u7LkUMUPcAAMeta } from "/app/pages/(dashboard)/cms/serial-number/index.vue?macro=true";
import { default as createYWeCESmzuqChfyfDGjgMq9Bn16Zd8itYvkESE9VxY_YMeta } from "/app/pages/(dashboard)/cms/serial-number/create.vue?macro=true";
import { default as _91id_93nO2RxjmpeY93Qg4RSFDb8r_5W_45AFLArxXNXCCQLJQ7gMeta } from "/app/pages/(dashboard)/cms/electrician/edit/[id].vue?macro=true";
import { default as _91id_939BJAnf_xiwkTf1UIEKCPKCRpIT8EYjn3S_45OoJApDm20Meta } from "/app/pages/(dashboard)/cms/electrician/view/[id].vue?macro=true";
import { default as _91id_93HHGVeZmtoWSNYfli1vStPXQwkRjOsaUlay7xXS9_gvsMeta } from "/app/pages/(dashboard)/cms/serial-number/view/[id].vue?macro=true";
import { default as barcodekYn5mgUyephQoE1XZSOw4kfX3fQhGs9TmmTJG7zLBzgMeta } from "/app/pages/(dashboard)/cms/shipping/amazon/barcode.vue?macro=true";
export default [
  {
    name: "login",
    path: "/login",
    meta: login0BGgKyS9MO99R8r15dbT80saTSiz17hh1jwvSebIrDMMeta || {},
    component: () => import("/app/pages/(auth)/login.vue")
  },
  {
    name: "test",
    path: "/test",
    component: () => import("/app/pages/(dashboard)/test.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/(dashboard)/index.vue")
  },
  {
    name: "error",
    path: "/:error(.*)*",
    meta: _91_46_46_46error_93XyHIKHCvvRYobyLISpXH15MUGAQ_vTHAKGVa8qYP0oUMeta || {},
    component: () => import("/app/pages/(dashboard)/[...error].vue")
  },
  {
    name: partnerBYIksIcGIwN6f8_45LhQ0QAG1Ud5F_45P6D8FfV82baWDmoMeta?.name,
    path: "/cms/partner",
    component: () => import("/app/pages/(dashboard)/cms/partner.vue"),
    children: [
  {
    name: "cms-partner",
    path: "",
    component: () => import("/app/pages/(dashboard)/cms/partner/(index)/index.vue")
  },
  {
    name: "cms-partner-create",
    path: "create",
    component: () => import("/app/pages/(dashboard)/cms/partner/(index)/create.vue")
  },
  {
    name: "cms-partner-edit-id",
    path: "edit/:id()",
    meta: _91id_93BvTr9ieAV5JQr1FJW1hPcOQI4heqt_45cdjbJUPq6e598Meta || {},
    component: () => import("/app/pages/(dashboard)/cms/partner/(index)/edit/[id].vue")
  },
  {
    name: "cms-partner-application",
    path: "application",
    component: () => import("/app/pages/(dashboard)/cms/partner/application/index.vue")
  }
]
  },
  {
    name: "currency",
    path: "/currency",
    component: () => import("/app/pages/(dashboard)/currency/index.vue")
  },
  {
    name: "cms-sheets-refund",
    path: "/cms/sheets/refund",
    meta: refundjvBE3p2wN5aZSU5BugNj6qGSLQ5ZewtdUfwPi8wl8a0Meta || {},
    component: () => import("/app/pages/(dashboard)/cms/sheets/refund.vue")
  },
  {
    name: "cms-shipping-ikas",
    path: "/cms/shipping/ikas",
    component: () => import("/app/pages/(dashboard)/cms/shipping/ikas.vue")
  },
  {
    name: "cms-sheets-support",
    path: "/cms/sheets/support",
    meta: supportk1S3T_0OLxcv8k4zQioO6p_45hDV9cjyOW5a0qDmwjKMgMeta || {},
    component: () => import("/app/pages/(dashboard)/cms/sheets/support.vue")
  },
  {
    name: "cms-electrician",
    path: "/cms/electrician",
    component: () => import("/app/pages/(dashboard)/cms/electrician/index.vue")
  },
  {
    name: "cms-electrician-create",
    path: "/cms/electrician/create",
    component: () => import("/app/pages/(dashboard)/cms/electrician/create.vue")
  },
  {
    name: "cms-serial-number",
    path: "/cms/serial-number",
    component: () => import("/app/pages/(dashboard)/cms/serial-number/index.vue")
  },
  {
    name: "cms-serial-number-create",
    path: "/cms/serial-number/create",
    component: () => import("/app/pages/(dashboard)/cms/serial-number/create.vue")
  },
  {
    name: "cms-electrician-edit-id",
    path: "/cms/electrician/edit/:id()",
    meta: _91id_93nO2RxjmpeY93Qg4RSFDb8r_5W_45AFLArxXNXCCQLJQ7gMeta || {},
    component: () => import("/app/pages/(dashboard)/cms/electrician/edit/[id].vue")
  },
  {
    name: "cms-electrician-view-id",
    path: "/cms/electrician/view/:id()",
    meta: _91id_939BJAnf_xiwkTf1UIEKCPKCRpIT8EYjn3S_45OoJApDm20Meta || {},
    component: () => import("/app/pages/(dashboard)/cms/electrician/view/[id].vue")
  },
  {
    name: "cms-serial-number-view-id",
    path: "/cms/serial-number/view/:id()",
    component: () => import("/app/pages/(dashboard)/cms/serial-number/view/[id].vue")
  },
  {
    name: "cms-shipping-amazon-barcode",
    path: "/cms/shipping/amazon/barcode",
    component: () => import("/app/pages/(dashboard)/cms/shipping/amazon/barcode.vue")
  }
]